const normalizeAppioStars = () => {
  document.querySelectorAll('.appio-star').forEach((star) => {
    const value = star.textContent.trim();

    if (value === '£') {
      star.textContent = '★';
      star.classList.add('miyabiya-appio-star-filled');
      star.classList.remove('miyabiya-appio-star-empty');
    }

    if (value === '¤') {
      star.textContent = '☆';
      star.classList.add('miyabiya-appio-star-empty');
      star.classList.remove('miyabiya-appio-star-filled');
    }
  });
};

const cleanProductCardReviews = () => {
  document.querySelectorAll("product-card [ref='productTitleLink']").forEach((titleLink) => {
    titleLink.querySelectorAll('.appio-star').forEach((star) => {
      star.remove();
    });

    const walker = document.createTreeWalker(titleLink, NodeFilter.SHOW_TEXT);
    const textNodes = [];

    while (walker.nextNode()) {
      textNodes.push(walker.currentNode);
    }

    textNodes.forEach((node) => {
      const cleaned = node.textContent
        .replace(/[☆★]/g, '')
        .replace(/\(\s*\d+\s+reviews?\s*\)/gi, '')
        .replace(/\s{2,}/g, ' ');

      node.textContent = cleaned;
    });
  });
};

const translateAppioReviewsForJapanese = () => {
  const isJapanese = document.documentElement.lang?.toLowerCase().startsWith('ja');

  if (!isJapanese) return;

  const monthMap = {
    January: '1月',
    February: '2月',
    March: '3月',
    April: '4月',
    May: '5月',
    June: '6月',
    July: '7月',
    August: '8月',
    September: '9月',
    October: '10月',
    November: '11月',
    December: '12月',
  };

  const exactTranslations = new Map([
    ['Customer Reviews', 'お客様レビュー'],
    ['Write a review', 'レビューを書く'],
    ['Powered by', '提供'],
    ['No reviews yet', 'まだレビューはありません'],
    ['Be the first to write a review', '最初のレビューを投稿する'],
    ['Submit Review', 'レビューを送信'],
    ['Submit review', 'レビューを送信'],
    ['Cancel', 'キャンセル'],
    ['Close', '閉じる'],
    ['Name', 'お名前'],
    ['Email', 'メールアドレス'],
    ['Rating', '評価'],
    ['Review', 'レビュー'],
    ['Review Title', 'レビュータイトル'],
    ['Review title', 'レビュータイトル'],
    ['Your review', 'レビュー内容'],
    ['Your name', 'お名前'],
    ['Your email', 'メールアドレス'],
  ]);

  const translateText = (value) => {
    const trimmed = value.trim();

    if (!trimmed) return value;

    if (exactTranslations.has(trimmed)) {
      return value.replace(trimmed, exactTranslations.get(trimmed));
    }

    const basedOnMatch = trimmed.match(/^Based on\s+([0-9,]+)\s+reviews?$/i);
    if (basedOnMatch) {
      return value.replace(trimmed, `${basedOnMatch[1]}件のレビューに基づく`);
    }

    const dateMatch = trimmed.match(
      /^(January|February|March|April|May|June|July|August|September|October|November|December)\s+([0-9]{1,2}),\s+([0-9]{4})$/
    );
    if (dateMatch) {
      return value.replace(trimmed, `${dateMatch[3]}年${monthMap[dateMatch[1]]}${dateMatch[2]}日`);
    }

    return value;
  };

  const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
    acceptNode(node) {
      const parent = node.parentElement;

      if (!parent) return NodeFilter.FILTER_REJECT;
      if (parent.closest('script, style, textarea')) return NodeFilter.FILTER_REJECT;

      return NodeFilter.FILTER_ACCEPT;
    },
  });

  const textNodes = [];

  while (walker.nextNode()) {
    textNodes.push(walker.currentNode);
  }

  textNodes.forEach((node) => {
    const translated = translateText(node.textContent);

    if (translated !== node.textContent) {
      node.textContent = translated;
    }
  });

  document.querySelectorAll('[aria-label], [title], input[placeholder], textarea[placeholder]').forEach((element) => {
    ['aria-label', 'title', 'placeholder'].forEach((attribute) => {
      const currentValue = element.getAttribute(attribute);

      if (!currentValue) return;

      const translated = translateText(currentValue);

      if (translated !== currentValue) {
        element.setAttribute(attribute, translated);
      }
    });
  });
};

const hideAppioReviewsForJapanese = () => {
  const isJapanese = document.documentElement.lang?.toLowerCase().startsWith('ja');

  if (!isJapanese) return;

  const reviewTextPattern =
    /Customer Reviews|Write a review|Based on\s+[0-9,]+\s+reviews?|Powered by\s+Appio|レビューを書く|お客様レビュー/i;

  document
    .querySelectorAll(
      [
        "[class*='appio' i]",
        "[id*='appio' i]",
        "[href*='apps.shopify.com/product-reviews-by-appio']",
      ].join(',')
    )
    .forEach((element) => {
      if (element.closest('product-card, .product-card')) return;

      const appBlock = element.closest('.shopify-block, [id^="shopify-block-"]');
      const target = appBlock && reviewTextPattern.test(appBlock.textContent || '') ? appBlock : element;

      target.setAttribute('hidden', '');
      target.style.setProperty('display', 'none', 'important');
    });

  document.querySelectorAll('main .shopify-block, main [id^="shopify-block-"]').forEach((section) => {
    if (section.closest('product-card, .product-card')) return;
    if (!reviewTextPattern.test(section.textContent || '')) return;

    section.setAttribute('hidden', '');
    section.style.setProperty('display', 'none', 'important');
  });
};

normalizeAppioStars();
cleanProductCardReviews();
hideAppioReviewsForJapanese();

const appioStarObserver = new MutationObserver(() => {
  normalizeAppioStars();
  cleanProductCardReviews();
  hideAppioReviewsForJapanese();
});
appioStarObserver.observe(document.documentElement, {
  childList: true,
  subtree: true,
});

const polishProductTitle = () => {
  const productTitle = document.querySelector('main h1');

  if (!productTitle) return;

  const title = productTitle.textContent.trim();
  const polishedTitle = title
    .replace(/\s+Recommended Age:.*/i, '')
    .replace(/\s+Tamagotchi Paradise$/i, '')
    .trim();

  if (polishedTitle && polishedTitle !== title) {
    productTitle.textContent = polishedTitle;
  }
};

polishProductTitle();
